import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import { getAgencyManagersAndSubordinatesById } from 'features/views/settings/marketPlaceAgencies/selectors';

import Manager from './Manager';

export const ManagersList = ({ agency }) => {
	const agencyManagersAndSubordinates = useSelector((state) =>
		getAgencyManagersAndSubordinatesById(state, agency?.areaId),
	);

	return (
		<ComponentLoader fetchStorePath={fetch.constants.urls.settingsMarketPlaceAgencyManagersAndSubordinates}>
			<Stack spacing={4}>
				{!isNilOrEmpty(agencyManagersAndSubordinates) &&
					agencyManagersAndSubordinates.map((manager) => <Manager manager={manager} agency={agency} />)}
			</Stack>
		</ComponentLoader>
	);
};

ManagersList.propTypes = {
	agency: PropTypes.object,
};

export default ManagersList;
